/**
 * Keep in sync with functions/abuseKeywords.js.
 */

export function findBlockedKeyword(text, keywords) {
  const hay = String(text || "").toLowerCase();
  const list = Array.isArray(keywords) ? keywords : [];
  for (const raw of list) {
    const keyword = String(raw || "").trim().toLowerCase();
    if (keyword.length < 3) continue;
    if (hay.includes(keyword)) return keyword;
  }
  return "";
}

export function contentBlob(row) {
  if (!row || typeof row !== "object") return "";
  return [row.title, row.subtitle, row.content, row.contentPreview].filter(Boolean).join("\n");
}
